import { queryKeys } from './useQueryAccountItemMeta'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { useFetchAccountItemMeta } from './useFetchAccountItemMeta'

const createBatch = () => {
  const { createBatch } = useFetchAccountItemMeta()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: createBatch,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const updateBatch = () => {
  const { updateBatch } = useFetchAccountItemMeta()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: updateBatch,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const dropBatch = () => {
  const { dropBatch } = useFetchAccountItemMeta()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: dropBatch,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

export const useMutationAccountItemMeta = {
  createBatch,
  updateBatch,
  dropBatch,
}
